import { Confirm } from "../components/confirmpage";
import { Footer, Nav } from "../components/layout";

const ConfirmPage = () => {
  return (
    <div className="">
      <Nav />
      <Confirm />
      <Footer />
    </div>
  );
};

export default ConfirmPage;
